import { useRef, useState } from "react"

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material"

function usePromptDialog(isValid: (value: string) => boolean) {
  const [resolve, setResolve] = useState<((value: string) => void) | null>(null)
  const [open, isOpen] = useState(false)
  const [title, setTitle] = useState("")
  const [text, setText] = useState("")
  const value = useRef("")

  const handleClose = (accepted: boolean) => {
    isOpen(false)
    if (accepted && resolve && isValid(value.current)) {
      resolve(value.current)
    }
    setResolve(null)
  }

  const openPrompt = (title: string, text: string) => {
    isOpen(true)
    setTitle(title)
    setText(text)
    return new Promise<string>(res => {
      setResolve(() => () => res(value.current))
    })
  }

  return {
    Prompt: ({ placeholder = "contrasena" }) => (
      <Dialog open={open} onClose={() => handleClose(false)}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>{text}</DialogContentText>
          <TextField
            size="small"
            fullWidth
            autoFocus
            placeholder={placeholder}
            id="prompt-confirm-value"
            onChange={event => {
              value.current = event.target.value
            }}
          />
        </DialogContent>
        <DialogActions sx={{ mb: 2 }}>
          <Button onClick={() => handleClose(true)} variant="contained">
            Confirmar
          </Button>
          <Button onClick={() => handleClose(false)}>Anular</Button>
        </DialogActions>
      </Dialog>
    ),
    openPrompt,
  }
}

export { usePromptDialog }
